///<reference path="../../../domain/category-repository.ts"/>
import { CategoryRepository } from "../../../domain/category-repository";
import { Injectable } from "@angular/core";
import { HttpService } from "../../http/http";
import { Category } from "../../../domain/category";

@Injectable()
export class CategoryRepositoryImpl implements CategoryRepository {
  cachedCategories: Array<Category> = new Array<Category>();

  constructor(private httpService: HttpService) {}

  getAllCategoris(): Promise<Array<Category>> {
    return Promise.resolve(this.cachedCategories);
  }

  init(): Promise<any> {
    var options = this.httpService.createDefaultRequestOptions();

    return this.httpService
      .getJSON("category", options)
      .then(
        (result: {
          success: boolean;
          message: Array<GetAllCategoriesResult>;
        }) => {
          if (result.message == null) {
            return null;
          }

          this.cachedCategories = result.message.map(
            (categoryResult) =>
              new Category(categoryResult.Id, categoryResult.Name),
          );
        },
      );
  }
}

class GetAllCategoriesResult {
  Id: number;
  Name: string;
}
